import { render, staticRenderFns } from "./automaticLabel.vue?vue&type=template&id=35b1f732&scoped=true&"
import script from "./automaticLabel.vue?vue&type=script&lang=js&"
export * from "./automaticLabel.vue?vue&type=script&lang=js&"
import style0 from "./automaticLabel.vue?vue&type=style&index=0&id=35b1f732&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b1f732",
  null
  
)

export default component.exports